import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PathwayDetails from './PathwayDetails';
import EditJourney from './EditJourney';
import './style.less';

function AppUserPathways() {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/pathway/:pathwayId`} component={PathwayDetails} />
      <Route path={`${match.path}/edit`} component={EditJourney} />
    </Switch>
  );
}

export default AppUserPathways;
